import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Photos from './pages/Photos';
import AlbumDetail from './pages/AlbumDetail';
import Vrienden from './pages/Vrienden';
import Nieuwjaarsreceptie from './pages/Nieuwjaarsreceptie';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/fotos" element={<Photos />} />
          <Route path="/fotos/:albumId" element={<AlbumDetail />} />
          <Route path="/vrienden" element={<Vrienden />} />
          <Route path="/nieuwjaarsreceptie" element={<Nieuwjaarsreceptie />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;